import {handleActions} from 'redux-actions';
import {HealthQuestionnaire} from '../constants/models';

const  HealthQuestionnaireReducers = handleActions({
    SET_HEALTH_QUESTIONNAIRE: (state, {payload}) => (
        state.merge({
            data: payload
        })
    ),
}, HealthQuestionnaire);

export default HealthQuestionnaireReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/HealthQuestionnaireReducers.jsx